module.exports = __webpack_public_path__ + "img/trustpilot.735077c.png";